import { render, staticRenderFns } from "./ShopShopType.vue?vue&type=template&id=53dd0c06&scoped=true&"
import script from "./ShopShopType.vue?vue&type=script&lang=js&"
export * from "./ShopShopType.vue?vue&type=script&lang=js&"
import style0 from "./ShopShopType.vue?vue&type=style&index=0&id=53dd0c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd0c06",
  null
  
)

export default component.exports